export default __webpack_public_path__ + "static/3-3d37c27b77a890908feba2d67f828523.jpeg";